import React, { PureComponent } from 'react';
import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import { connect } from 'react-redux';

import IssuesTabContainer from './IssuesTabContainer';

import { issueRelationshipTypeIdSelector } from '../../reducers/relationshipTypes';

const IssuesTabWrapperSelectors = immutableCreatorSelector(
  [
    issueRelationshipTypeIdSelector,
  ], (
    issueRelationshipTypeId,
  ) => ({
    issueRelationshipTypeId,
  })
);

@connect(IssuesTabWrapperSelectors)
class IssuesTabWrapper extends PureComponent {
  static propTypes = {
  };

  render() {
    return (
      <IssuesTabContainer {...this.props} />
    );
  }
}

export default IssuesTabWrapper;



// WEBPACK FOOTER //
// ./src/components/IssuesTab/index.js